import i18n from 'i18next'
import { isNative } from '@dhl/webview'
import { get } from '~/util/api/get'
import { getConfig, getTopLevelDomain } from '~/config'
import { PATH } from '~/links'
import { type PaymentProviderResult } from './types'
import { PaymentTypes } from '../../view/pages/overview/util/useFetchSupportedPaymentMethods'
import { LABEL, PAYMENT_FAILURE } from '../constants'

const getPaymentPathBasedOnBrand = (brand: string | undefined | null) => {
  switch (brand) {
    case undefined:
    case null:
      return undefined
    case PaymentTypes.Ideal:
      return 'Ideal/Ideal'
    case PaymentTypes.Visa:
      return 'CreditCard/Visa'
    case PaymentTypes.MasterCard:
      return 'CreditCard/MasterCard'
    case PaymentTypes.CreditCard:
      return 'CreditCard/CreditCard'
    case PaymentTypes.Swish:
      return 'Swish/Swish'
    default:
      throw new Error(`There is no support for payment based on brand ${brand}`)
  }
}

export const getNativeProtocol = () => {
  const tld = getTopLevelDomain()
  return tld === 'nl' ? 'dhlparcel://' : 'dhlparcelse://'
}

export const getPaymentProvider = (
  orderId: number,
  usePaymentService: boolean,
  brand: string | null,
  issuerId: string | null
): Promise<PaymentProviderResult> => {
  const paymentPath = getPaymentPathBasedOnBrand(brand)

  const { basePath } = getConfig()

  const callbackProtocol = `${window.location.protocol}//`
  const callbackHost = window.location.host
  const callbackQueryParams = `isNative=${isNative()}&locale=${i18n.language}`
  const callbackReturnPath = `${basePath}${PATH.BASKET}/${LABEL}`
  const callbackCancelPath = `${basePath}${PATH.BASKET}/${PAYMENT_FAILURE}`

  const baseUrl = `${callbackProtocol}${callbackHost}`
  const returnUrl = `${baseUrl}${callbackReturnPath}?orderId=${orderId}&${callbackQueryParams}`
  const cancelUrl = `${baseUrl}${callbackCancelPath}?${callbackQueryParams}`

  const params = new URLSearchParams()
  params.append('clientAppId', 'Pwa')
  params.append('isNative', isNative().toString())
  params.append('returnUrl', returnUrl)
  params.append('cancelUrl', cancelUrl)
  params.append('usePaymentService', usePaymentService.toString())

  if (brand === PaymentTypes.Ideal && issuerId) {
    params.append('issuerId', issuerId)
  }
  return get(`/api/orders/${orderId}/paymentinfo${paymentPath ? `/${paymentPath}` : ''}?${params.toString()}`)
}
